import React from 'react';
import {Route} from "src/config/routes";
import {KatIcon, KatLabel, KatDropdown} from "@amzn/katal-react";

import SubpageName from "src/model/SubpageName";
import {NavLink} from "react-router-dom";

export const STAGES = [
    { name: 'Beta', value: 'Beta' },
    { name: 'Gamma', value: 'Gamma' },
    { name: 'Prod', value: 'Prod' },
];

/** Parts of `window.location` needed to compute a stage swap. */
type StageLocation = Pick<Location, 'hostname' | 'pathname' | 'search' | 'hash' | 'protocol'>;

/** Derives the current stage from the hostname: portal.gamma.na.portal.fee... → Gamma. */
export function getStageFromHostname(hostname: string = window.location.hostname): string {
    const host = hostname.toLowerCase();
    if (host.includes('.gamma.')) return 'Gamma';
    if (host.includes('.prod.')) return 'Prod';
    return 'Beta';
}

/**
 * Pure: computes the same URL with the stage segment of the hostname swapped to `stage`,
 * preserving path, search and hash. Returns `null` when there is nothing to do — either the
 * hostname has no stage segment (e.g. localhost) or it is already on the requested stage.
 * Each stage is a separate deployment at its own hostname, so navigating here loads the target
 * stage's deployment with its own endpoint + Cognito pool.
 */
export function computeStageSwitchUrl(location: StageLocation, stage: string): string | null {
    const targetSegment = stage.toLowerCase();
    const { hostname, pathname, search, hash, protocol } = location;
    const segments = hostname.toLowerCase().split('.');
    const stageIndex = segments.findIndex(
        (segment) => segment === 'beta' || segment === 'gamma' || segment === 'prod'
    );
    if (stageIndex === -1 || segments[stageIndex] === targetSegment) {
        return null;
    }
    segments[stageIndex] = targetSegment;
    const newHostname = segments.join('.');
    return `${protocol}//${newHostname}${pathname}${search}${hash}`;
}

/** Navigates the browser to the target stage's deployment, if the swap is applicable. */
function switchStage(stage: string): void {
    const target = computeStageSwitchUrl(window.location, stage);
    if (target !== null) {
        window.location.href = target;
    }
}

interface HeaderProps {
    routes: Route[];
    currentSubPage: SubpageName;
}

interface State {
}

export class HeaderComponent extends React.Component<HeaderProps, State> {

    constructor(props: HeaderProps) {
        super(props);
    }

    render() {
        return (
            <div id="app-header">
                <div className="app-header-logo">
                    <KatIcon name="monetization_on" size="medium"/>
                    <KatLabel className="header-title" text="FeeSXTech Portal"/>
                </div>
                <nav className="app-header-toggle">
                    {
                        this.props.routes.map(({title, href, name}) => (
                        <NavLink key={'header-' + name} className={"nav-link"} to={href}>
                            {title}
                        </NavLink>
                    ))}
                </nav>
                <div className="header-stage-selector">
                    <KatDropdown
                        value={getStageFromHostname(window.location.hostname)}
                        options={JSON.stringify(STAGES)}
                        onChange={(e: any) => switchStage(e.detail?.value || 'Beta')}
                    />
                </div>
            </div>
        );
    }
}
